import React from 'react';
import propTypes from 'prop-types';

import moment from '~/Providers/Moment';

import './CounterColumn.scss';

const CounterColumn = ({ showMeridian }) => {
  const day = moment('2020-01-01', 'YYYY-MM-DD');
  return (
    <div className="counter-column">
      {[...Array(24)].map((val, index) => {
        day.startOf('day');
        const format = showMeridian ? 'h a' : 'h';
        return (
          <div key={index} className="counter-box">
            {day.add(index, 'hour').format(format)}
          </div>
        );
      })}
    </div>
  );
};

export default CounterColumn;

CounterColumn.propTypes = {
  showMeridian: propTypes.bool,
};

CounterColumn.defaultProps = {
  showMeridian: false,
};
